import React from 'react';
import './Illustrations.css';

const BUBBLE_PATH =
  'M24 14 H56 Q70 14 70 28 V40 Q70 54 56 54 H38 L24 66 L27 54 H24 Q10 54 10 40 V28 Q10 14 24 14 Z';

/**
 * "Enkelt å bruke": a screen with a check mark and a pointer.
 * @returns {JSX.Element} Decorative drawing
 */
export function EasyIcon() {
  return (
    <svg className="illustration" viewBox="0 0 80 80" aria-hidden="true" focusable="false">
      <rect className="ill-white" x="10" y="14" width="56" height="42" rx="9" />
      <rect className="ill-line-navy" x="10" y="14" width="56" height="42" rx="9" />
      <path className="ill-line-orange" d="M25 35 L34 44 L51 27" />
      <path className="ill-navy" d="M50 46 L50 72 L57 65 L62 75 L67 72 L62 63 L71 62 Z" />
    </svg>
  );
}

/**
 * "Ingen økonomibakgrunn": a speech bubble that smiles, for plain words.
 * @returns {JSX.Element} Decorative drawing
 */
export function PlainWordsIcon() {
  return (
    <svg className="illustration" viewBox="0 0 80 80" aria-hidden="true" focusable="false">
      <path className="ill-white" d={BUBBLE_PATH} />
      <path className="ill-line-navy" d={BUBBLE_PATH} />
      <circle className="ill-navy" cx="31" cy="29" r="3.5" />
      <circle className="ill-navy" cx="49" cy="29" r="3.5" />
      <path className="ill-line-orange" d="M29 38 Q40 48 51 38" />
    </svg>
  );
}

/**
 * "Lett å komme i gang": a plug with its cable, and a few sparks for "it's on".
 * @returns {JSX.Element} Decorative drawing
 */
export function PlugIcon() {
  return (
    <svg className="illustration" viewBox="0 0 80 80" aria-hidden="true" focusable="false">
      <path className="ill-line-navy" d="M33 34 L33 20 M47 34 L47 20" />
      <path className="ill-orange" d="M24 32 H56 V42 Q56 56 40 56 Q24 56 24 42 Z" />
      <path className="ill-line-navy" d="M40 56 L40 62 Q40 70 50 70 L68 70" />
      <path className="ill-line-gold" d="M14 22 L20 26 M12 38 L19 38 M66 22 L60 26 M68 38 L61 38" />
    </svg>
  );
}
